export default "__VITE_ASSET__BM0NnVM9__"